import { GVLoadingBackdrop, VerifyDialog } from '../../components/common';
import React, { Dispatch, SetStateAction } from 'react';
import { Copy } from '@globalvisioninc/assets/icons';
import { Button } from '@globalvisioninc/ui/button';
import { GVTypography } from '../../components/lib';
import GVTextField from '../../components/lib/GVTextField/GVTextField';
import { useDispatch } from 'react-redux';
import { app } from '../../store';
import styles from './CreateApiKeyDialog.module.css';

const CreateApiKeyDialog = ({
  apiKeyName,
  setApiKeyNameFn,
  mutationPending,
  rawKey,
  isOpen,
  actionFn,
  closeFn,
}: {
  apiKeyName: string;
  setApiKeyNameFn: Dispatch<SetStateAction<string>>;
  mutationPending: boolean;
  rawKey: string | undefined;
  isOpen: boolean;
  actionFn: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  closeFn: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}) => {
  const CopyButton = ({ text }: { text: string }) => {
    const dispatch = useDispatch();

    const handleClick = () => {
      navigator.clipboard.writeText(text);
      dispatch(app.actions.setSnackMessage({ message: 'Copied to Clipboard', type: 'success' }));
    };

    return (
      <Button.Root type="button" mode="tertiary" aria-label="Copy API key" onClick={handleClick}>
        <Copy />
      </Button.Root>
    );
  };

  const buildApiKeyModalBody = () => {
    // show a spinner while creating an API Key
    if (mutationPending) {
      return (
        <>
          <GVLoadingBackdrop />
        </>
      );
    }

    // if we created an API Key, show it, so it's copied
    if (rawKey) {
      return (
        <>
          <GVTypography>Please copy your API Key, only at this time it will be visible</GVTypography>
          <GVTextField
            className={styles.field}
            elementEnd={<CopyButton text={rawKey} />}
            value={rawKey}
            placeholder="API Key"
            label="API Key"
            isLabelHidden
            isReadOnly
          />
        </>
      );
    }

    // Sow the form to put the name of the API key
    return (
      <>
        <GVTextField
          label="Api Key Name"
          className={styles.field}
          value={apiKeyName}
          onValueChange={(value) => setApiKeyNameFn(value ?? '')}
        />
      </>
    );
  };

  let subTitle = 'Are you sure you want to create a new API key?';
  if (rawKey && !mutationPending) {
    subTitle = 'API Key generated successfully';
  }

  return (
    <VerifyDialog
      title="API Key"
      subTitle={subTitle}
      children={buildApiKeyModalBody()}
      callToActionText="Yes"
      hideCallToAction={rawKey !== undefined}
      handleCallToActionClick={actionFn}
      iconType=""
      isDivider
      dismiss={true}
      open={isOpen}
      handleCloseModal={closeFn}
    />
  );
};

export default CreateApiKeyDialog;
